import type { ProfileDto } from '../dtos/user-profile.dto'

export const ADAMO_PAY_PRODUCT_KEY = 'adamo_pay'

export function hasAdamoPayProductAccess(profile: ProfileDto): boolean {
  return profile.allowedProducts?.includes(ADAMO_PAY_PRODUCT_KEY) ?? false
}
